// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICustomerIndividualNameSuffixType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class CustomerIndividualNameSuffixType implements ICustomerIndividualNameSuffixType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns JR CustomerIndividualNameSuffixType
	**/
    get JR(): ICustomerIndividualNameSuffixType {
        return this.FromId(1);
    }
    /**
		Returns SR  CustomerIndividualNameSuffixType
	**/
    get SR(): ICustomerIndividualNameSuffixType {
        return this.FromId(2);
    }
    /**
		Returns I  CustomerIndividualNameSuffixType
	**/
    get I(): ICustomerIndividualNameSuffixType {
        return this.FromId(3);
    }
    /**
		Returns II CustomerIndividualNameSuffixType
	**/
    get II(): ICustomerIndividualNameSuffixType {
        return this.FromId(4);
    }
    /**
		Returns III CustomerIndividualNameSuffixType
	**/
    get III(): ICustomerIndividualNameSuffixType {
        return this.FromId(5);
    }
    /**
		Returns IV CustomerIndividualNameSuffixType
	**/
    get IV(): ICustomerIndividualNameSuffixType {
        return this.FromId(6);
    }
    /**
		Returns V  CustomerIndividualNameSuffixType
	**/
    get V(): ICustomerIndividualNameSuffixType {
        return this.FromId(7);
    }
    /**
		Returns VI CustomerIndividualNameSuffixType
	**/
    get VI(): ICustomerIndividualNameSuffixType {
        return this.FromId(8);
    }
    /**
		Returns VII  CustomerIndividualNameSuffixType
	**/
    get VII(): ICustomerIndividualNameSuffixType {
        return this.FromId(9);
    }
    /**
		Returns VIII  CustomerIndividualNameSuffixType
	**/
    get VIII(): ICustomerIndividualNameSuffixType {
        return this.FromId(10);
    }
    /**
		Returns IX   CustomerIndividualNameSuffixType
	**/
    get IX(): ICustomerIndividualNameSuffixType {
        return this.FromId(11);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'JR', displayValue: 'JR', description: 'Junior', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'SR', displayValue: 'SR ', description: 'Senior', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'I', displayValue: 'I', description: 'First', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'II', displayValue: 'II', description: 'Second', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: 'III', displayValue: 'III', description: 'Third', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: 'IV', displayValue: 'IV', description: 'Fourth', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, value: 'V', displayValue: 'V', description: 'Fifth', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, value: 'VI', displayValue: 'VI', description: 'Sixth', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, value: 'VII', displayValue: 'VII', description: 'Seventh', sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, value: 'VIII', displayValue: 'VIII', description: 'Eighth', sortOrder: 10, active: true });
        this._dictionary.add('11', { id: 11, value: 'IX', displayValue: 'IX', description: 'Ninth', sortOrder: 11, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICustomerIndividualNameSuffixType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICustomerIndividualNameSuffixType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICustomerIndividualNameSuffixType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICustomerIndividualNameSuffixType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICustomerIndividualNameSuffixType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
